import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgShopping} from "~/assets/svg/shopping.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmShoppingIcon: React.FC<IIconBase> = ({id, size = "xs", color = designColors.black, className}) => {
  return <SvgShopping id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
